@if (opened) {
  <aside class="history" (appClickOutside)="clickOutside()"  [ngClass]="{'history_opened': opened}" [@slideLeft]>
    @if (historyElements) {
      <ul class="history__list">
        @for (element of historyElements.history; track element) {
          <li class="history__element">
            <a class="icon" [ngClass]="{'icon_star-simple': !element.favorites, 'icon_star-active': element.favorites}"></a>
            <a class="history__element__caption" href="javascript:void(0)" (click)="routerLink(element.url)">{{element.caption}}</a>
          </li>
        }
      </ul>
    }
  </aside>
}
